import React from 'react';

const Checkbox = ({ checked, onChange }) => (
  <div className="flex items-center">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="hidden"
    />
    <div
      className={`w-4 h-4 border-2 rounded-sm flex items-center justify-center cursor-pointer ${
        checked ? 'bg-blue-500 border-blue-500' : 'bg-white border-gray-300'
      }`}
      onClick={onChange}
    >
      {checked && <p className="text-white">✓</p>}
    </div>
  </div>
);

export default Checkbox;
